export const InstanceOpinometroActionTypes = {
  API_RESPONSE_SUCCESS: '@@instance-opinometro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@instance-opinometro/API_RESPONSE_ERROR',

  GET_INSTANCE_OPINOMETRO: '@@instance-opinometro/GET_INSTANCE_OPINOMETRO',
  LIST_INSTANCE_OPINOMETROS: '@@instance-opinometro/LIST_INSTANCE_OPINOMETROS',
  ADD_INSTANCE_OPINOMETRO: '@@instance-opinometro/ADD_INSTANCE_OPINOMETRO',
  UPDATE_INSTANCE_OPINOMETRO: '@@instance-opinometro/UPDATE_INSTANCE_OPINOMETRO',
  DELETE_INSTANCE_OPINOMETRO: '@@instance-opinometro/DELETE_INSTANCE_OPINOMETRO',

  RESET: '@@instance-opinometro/RESET'
}
